import { observable, action } from 'mobx';

import CodeCellStore from './CodeCellStore';

export default class PlaygroundStore {
  @observable cells: CodeCellStore[] = [];

  @action
  setSelected(cell: CodeCellStore, isSelected: boolean) {
    const c = this.cells.find((c) => c === cell);
    if (c) {
      this.cells.forEach((c) => c.selected = false);
      c.selected = isSelected;
    }
  }

  @action
  executeSelectedScript() {
    const cellIndex = this.cells.findIndex((c) => c.selected);
    const cell = this.cells[cellIndex];
    if (cell) {
      cell.execute()
        .then(() => {
          // tslint:disable-next-line:no-console
          console.log('Cell executed:', cell);
          if (cellIndex + 1 < this.cells.length) {
            this.setSelected(this.cells[cellIndex + 1], true);
          }
        });
    }
  }
}
